import { api } from '../../../shared/services/api'
import type { AuthResponse, User } from '../types/auth.types'

export const authApi = {
  login: (email: string, password: string) => api.post<AuthResponse>('/auth/login', { email, password }),
  me: () => api.get<User>('/auth/me'),
  microsoftStartUrl: () => `${api.defaults.baseURL}/auth/microsoft/start`,
}
